import { dynamicArray } from "neetocist";
import { dayjs } from "neetocommons/utils";

export const disabledDate = current =>
  current && current < dayjs().startOf("day");

export const disabledTime = selectedDate => {
  const current = dayjs(selectedDate).startOf("day");
  const today = dayjs().startOf("day");

  if (current.isBefore(today)) {
    return { disabledHours: () => dynamicArray(24, i => i) };
  }

  if (current.isSame(today)) {
    const currentTime = dayjs();

    return {
      disabledHours: () => dynamicArray(currentTime.hour() + 1, i => i),
    };
  }

  return {};
};

export const getDefaultDate = () => {
  let currDate = dayjs();
  currDate = currDate.hour(currDate.hour() + 1);

  if (currDate.minute() > 30) {
    currDate = currDate.hour(currDate.hour() + 1);
  }

  return currDate;
};
